<template>
  <h6 class="text-center py-5">
    دیتایی برای نمایش وجود ندارد
  </h6>
</template>

<script>
export default {
  name: 'ChartNoDataMessage',
}
</script>
